import { apiHttpService } from './apiHttpService';
import { Code } from '../domains/app';

export const createGroupCode = (
  spaceId: string,
  groupIds: string[],
  min: number,
): Promise<string> => {
  return apiHttpService
    .post(
      `/api/Integration/token/create/space/${spaceId}?minutes=${min}`,
      groupIds,
    )
    .then((response) => response.data);
};

export const createPersonalCode = (
  userId: string,
  min: number,
): Promise<string> => {
  return apiHttpService
    .post(`/api/Integration/token/create/person/${userId}?minutes=${min}`, {})
    .then((response) => response.data);
};

export const createMembersCode = (
  spaceId: string,
  memberIds: string[],
  min: number,
): Promise<string> => {
  return apiHttpService
    .post(
      `/api/Integration/token/create/space/${spaceId}/member?minutes=${min}`,
      memberIds,
    )
    .then((response) => response.data);
};

export const getSpaceCodes = (spaceId: string): Promise<Code[]> => {
  return apiHttpService
    .get(`/api/Integration/token/space/${spaceId}`)
    .then((response) => response.data);
};

export const getPersonalCodes = (userId: string): Promise<Code[]> => {
  return apiHttpService
    .get(`/api/Integration/token/person/${userId}`)
    .then((response) => response.data);
};

// eslint-disable-next-line
export default {
  createGroupCode,
  createPersonalCode,
  getSpaceCodes,
  getPersonalCodes,
  createMembersCode,
};
